import React, { useEffect, useState } from "react";
import { Box, Link as MuiLink, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { API } from "../constant/apiConstant";
import { Colors } from "../utils/colors";

const footerDefaults = {
  brandName: "Flip Lottery",
  poweredByText: "Product of Flip Games Limited",
  licenseText: "Delta State Licensed • NDPR Compliant",
  copyrightText: "© 2026 Flip Games Limited. All rights reserved.",
  locationText: "Delta State, Nigeria",
  supportEmail: "support@fliplottery.com",
  supportPhone: "+234 800 000 0000"
};

export default function LegalFooter() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await fetch(`${API.BASE_URL}/api/settings`);
        const data = await response.json();

        if (data?.status) {
          setSettings(data.settings || null);
        }
      } catch (error) {
        console.log(error);
      }
    };

    loadSettings();
  }, []);

  const socialLinks = [
    { label: "Facebook", url: settings?.facebook_url },
    { label: "Instagram", url: settings?.instagram_url },
    { label: "X", url: "https://x.com/Fliplottery" }
  ].filter((link) => Boolean(link.url));

  const supportEmail = settings?.support_email || footerDefaults.supportEmail;

  return (
    <Box
      component="footer"
      sx={{
        mt: 0,
        // Keep the last footer links above the fixed navigation on every viewport.
        mb: "calc(84px + env(safe-area-inset-bottom, 0px))",
        px: { xs: 2, md: 4 },
        py: 3,
        background:
          "linear-gradient(180deg, rgba(4, 28, 47, 0.96) 0%, rgba(7, 41, 68, 0.98) 100%)",
        color: "#fff"
      }}
    >
      <Stack spacing={1} alignItems="center">
        <Typography sx={{ color: Colors.accent, fontWeight: 700, letterSpacing: 0.4 }}>
          {settings?.footer_brand_name || footerDefaults.brandName}
        </Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.78)", textAlign: "center" }}>
          {settings?.footer_powered_by_text || footerDefaults.poweredByText}
        </Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.78)", textAlign: "center" }}>
          {settings?.footer_license_text || footerDefaults.licenseText}
        </Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.78)", textAlign: "center" }}>
          {settings?.footer_copyright_text || footerDefaults.copyrightText}
        </Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.86)", textAlign: "center" }}>
          {supportEmail}
        </Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.78)", textAlign: "center" }}>
          {settings?.support_phone || footerDefaults.supportPhone}
        </Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.72)", textAlign: "center" }}>
          {settings?.footer_location_text || footerDefaults.locationText}
        </Typography>
        {socialLinks.length > 0 ? (
          <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center">
            {socialLinks.map((link) => (
              <MuiLink
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noreferrer"
                underline="hover"
                sx={{ color: "#39ff14", fontWeight: 700 }}
              >
                {link.label}
              </MuiLink>
            ))}
          </Stack>
        ) : null}
        <Stack direction="row" spacing={3} flexWrap="wrap" justifyContent="center">
          <MuiLink
            component={RouterLink}
            to="/terms-and-conditions"
            underline="hover"
            sx={{ color: Colors.accent, fontWeight: 600 }}
          >
            Terms and Conditions
          </MuiLink>
          <MuiLink
            component={RouterLink}
            to="/privacy-policy"
            underline="hover"
            sx={{ color: Colors.accent, fontWeight: 600 }}
          >
            Privacy Policy
          </MuiLink>
        </Stack>
      </Stack>
    </Box>
  );
}
